import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="drawer"
export default class extends Controller<HTMLElement> {
  close() {
    // @ts-expect-error: TypeScript < 5.2 does not support Popover API
    this.element.hidePopover();
  }

  load() {
    // @ts-expect-error: TypeScript < 5.2 does not support Popover API
    this.element.showPopover();
    this.element.focus();
  }
}
